<template>
  <div id="app">
    <router-view></router-view>
    <notifications />
  </div>
</template>

<script>
  import Vue from 'vue'
  import Notifications from 'vue-notification'
  import Vuelidate from 'vuelidate'
  import 'vuelidate/dist/vuelidate.min.js'
  import 'vuelidate/dist/validators.min.js'
  Vue.use(Vuelidate)
  Vue.use(Notifications)
  import axios from 'axios'
  import $ from 'jquery'
  import { TOKEN_INVALID_CODES } from '../assets/js/token-error.js'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'App',
    data () {
      return {
        section: 'Head'
      }
    },
    methods: {
      ...mapActions(['setToken', 'setUserInfo', 'clearUserInfo', 'setTradeTypeList', 'setRestrictList']),
      setLStorage (title, content) {
        window.localStorage.setItem(title, content)
      },
      getLStorage (title) {
        return window.localStorage.getItem(title)
      },
      fixedH () {
        const windowW = $(window).width()
        const windowH = $(window).height()
        const minH = windowH - 55
        this.$nextTick(function () {
          const bodyH = $('.content-wrapper').height()
          if (windowW >= 768 && bodyH < windowH) {
            $('.content-wrapper').css('min-height', minH + 'px')
          } else {
            $('.content-wrapper').css('min-height', 'none')
          }
        })
      },
      getData (method, url, data, callback) {
        const self = this
        axios({
          baseURL: this.$config.baseURL,
          method: method,
          url: url,
          data: data
        })
        .then((res) => {
          callback(res)
        })
        .catch((err) => {
          self.$notify({
            title: err.response ? err.response.data.message : '',
            text: err.response ? err.response.data.description : '',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        })
      },
      getDataH (method, url, data, callback, handleError) {
        const self = this
        axios({
          baseURL: this.$config.baseURL,
          method: method,
          url: url,
          data: data,
          headers: {
            'MC-API-Token': self.getToken
          }
        })
        .then(function (response) {
          if (response.data.token_need_replace === 1) {
            self.updateToken()
          } else {
            callback(response)
          }
        })
        .catch(function (error) {
          if (error.response) {
            // 如果為 token 無效的錯誤碼，清除所有用戶資訊並通知用戶重新登入
            if (TOKEN_INVALID_CODES.includes(error.response.data.status)) {
              self.clearAll()
            } else {
              if (handleError) {
                handleError(error)
              } else {
                self.$notify({
                  title: error.response.data.message,
                  text: error.response.data.description,
                  duration: 3000,
                  type: 'danger',
                  width: 400
                })
              }
            }
          }
        })
      },
      getFile (method, url, data, callback) {
        const self = this
        axios({
          responseType: 'blob',
          baseURL: this.$config.baseURL,
          method: method,
          url: url,
          data: data,
          headers: {
            'MC-API-Token': self.getToken
          }
        })
        .then(function (response) {
          callback(response)
        })
        .catch(function (error) {
          self.$notify({
            title: error.response.data.message,
            text: error.response.data.description,
            duration: 3000,
            type: 'danger',
            width: 400
          })
          callback(error.response)
        })
      },
      updateToken () {
        const self = this
        const url = '/auth/' + this.getUserId + '/replaceToken'
        this.getDataH('get', url, null, function (response) {
          const token = response.data.token
          self.setToken(token)
          self.setLStorage(self.$config.token, token)
        })
      },
      clearAll () {
        // 一個頁面常常同時打好幾支 API，token 失效時每一支都會進來一次。
        // 已經清掉就直接跳出，不然通知會疊好幾個、router 也被推好幾次。
        if (!this.getToken) return
        this.clearUserInfo()
        this.$notify({
          title: '登入已失效',
          text: '您的登入已失效或權限不足，請重新登入。',
          duration: 5000,
          type: 'danger',
          width: 400
        })
        this.$router.push('/login')
      },
      checkInput (str) {
        if (str) {
          str = str.toString()
          str = str.replace(/["']/g, '').trim()
        } else if (typeof str === 'number') {
          return '0'
        } else return ''
        return str
      },
      getTradeTypeList () {
        // 取得付款類型
        const url = '/platform/tradeTypeList'
        this.getData('get', url, null, (response) => {
          if (response.data.status === 200) {
            let data = response.data.list.filter(x => x.is_valid).map(x => {
              return {
                value: x.type,
                label: x.name
              }
            })
            data.unshift({label: '== 付款類型 ==', value: 999})
            this.setTradeTypeList(data)
          }
        })
      },
      getSubordinate (userId, roleType) {
        const self = this
        let roleTypeName = ''
        if (roleType === 99) {
          roleTypeName = 'admin'
        } else if (roleType === 30) {
          roleTypeName = 'brand'
        } else if (roleType === 10) {
          roleTypeName = 'store'
        }
        // 抽成對帳權限開開關
        let url = '/manager/' + roleTypeName + '/' + userId + '/subordinate'
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            let restricList = []
            let denyList = []
            let nidinLeague = 0
            if (response.data.subordinate.allowed_restricted_function_list) {
              restricList = response.data.subordinate.allowed_restricted_function_list
            }
            if (response.data.subordinate.denied_restricted_function_list) {
              denyList = response.data.subordinate.denied_restricted_function_list
            }
            if (response.data.subordinate.in_nidin_league) {
              nidinLeague = response.data.subordinate.in_nidin_league
            }
            self.$store.commit('SET_NIDIN_LEAGUE', nidinLeague)
            self.$store.commit('SET_RESTRICT', restricList)
            self.$store.commit('SET_DENYLIST', denyList)
          }
        })
      },
      setUserInfoToken () {
        const userId = this.getLStorage(this.$config.userId)
        const token = this.getLStorage(this.$config.token)
        const roleType = parseInt(this.getLStorage(this.$config.roleType), 10)
        const account = this.getLStorage(this.$config.account)
        if (userId && token && roleType) {
          this.setUserInfo({userId, token, roleType, account})
          this.setToken(token)
        }
      }
    },
    created () {
      this.fixedH()
      this.setUserInfoToken()
    },
    computed: {
      ...mapGetters(['getUserId', 'getToken'])
    },
    watch: {
      'getUserId' (val) {
        if (val) {
          const roleType = parseInt(this.getLStorage(this.$config.roleType), 10)
          this.getTradeTypeList()
          this.getSubordinate(val, roleType)
        }
      }
    }
  }
</script>

<style lang="sass">
.select-element:disabled, .select-element[disabled]
  pointer-events: none !important
.text-auto
  color: inherit
.input-group .input-group-addon
  border-color: #222d32
table thead tr th, .input-group .input-group-addon
  background: #222d32
  color: #fff
.input-addon-icon
  display: flex
  align-items: center
  height: 35.42px
  padding: 0 5px
  position: absolute
  right: 0
.main-footer
  z-index: 120 !important
tbody
  text-align: left
.paginate_button.active
  pointer-events: none
.notification-wrapper
  top: 50px
.vue-notification
  margin: 10px !important
.vue-notification .notification-title
  font-size: 18px
.vue-notification .notification-content
  font-size: 15px
.vue-notification.danger
  border-left: 5px solid #b82e24
  background: #e54d42
.h-38
  height: 38px !important
.form-control
  height: auto
  min-height: 34px
  font-size: 15px
.main-header, .main-footer
  z-index: 1000
.main-sidebar
  z-index: 200
$basic-color: #E1456D
.breadcrumb>li+li:before
  padding: 0px 0px 0px 3px
.m-h-700
  min-height: 700px
.box
  float: left
.c-pointer
  cursor: pointer !important
.c-auto
  cursor: auto !important
#app
  height: 100%
.m-b-10
  margin-bottom: 10px
.p-t-10
  padding-top: 10px
.text-w-600
  font-weight: 600
body, .btn
  font-size: 16px
.input-group-addon
  line-height: 20px
  font-size: 16px
  font-weight: 600
  letter-spacing: 2px
.form-control:focus
  border: 1px solid #ccc

*
  position: relative
  text-rendering: optimizelegibility
  -moz-osx-font-smoothing: grayscale
  -moz-text-size-adjust: none

*:focus
  outline: 0 !important
button
  background-color: #e4e0e5
.btn-pink
  background: $basic-color !important
  border: 0px
  color: white !important
  font-weight: 500

.w-100-p
  width: 100% !important

.h-100-p
  height: 100% !important

.text-35
  font-size: 35px !important

.m-t-5
  margin-top: 5px !important

.p-x-0
  padding-left: 0px !important
  padding-right: 0px !important

h2
  margin-top: 0px !important
  margin-bottom: 0px !important

.h-100
  height: 100px !important

.p-x-10
  padding-left: 10px !important
  padding-right: 10px !important

.btn-table-title
  padding: 4px 12px
.modal-dialog
  margin-top: 60px
.m-0.form-group
  margin: 0px !important
@media screen and (max-width: 991px)
  .notification-wrapper
    top: 100px
  .form-inline .input-group
    display: table
@media screen and (max-width: 767px)
  .modal-dialog
    margin-top: 110px
  .table-responsive
    border: none !important
.row
  margin-left: 0px
  margin-right: 0px

.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9
  padding-left: 0px
  padding-right: 0px
.th-fit
  width: 60px
.th-fat
  min-width: 150px
</style>



// WEBPACK FOOTER //
// App.vue?20314ecb